const sha256 = require('js-sha256');
module.exports = function (data) {
    data.preferences.Email = sha256(data.preferences.Email);
    return {
        event: 'BWSAUeDMunsubscribe',
        eventContext: {
            area: 'eDM unsubscribe page',
            commsPreference: data.preferences
       }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/unsubscribeedm/atm/unsubscribe-mapper.js
 **/